import { render, staticRenderFns } from "./SeatsClassifier.vue?vue&type=template&id=621a04ec&scoped=true"
import script from "./SeatsClassifier.vue?vue&type=script&lang=js"
export * from "./SeatsClassifier.vue?vue&type=script&lang=js"
import style0 from "./SeatsClassifier.vue?vue&type=style&index=0&id=621a04ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a04ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDataTable,VDivider})
